<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="d-flex justify-content-between align-center">
        <v-spacer></v-spacer>
        <v-icon @click="dialog = false">mdi-close</v-icon>
      </v-card-title>
      <v-card-text id="receiptDialog">
        <div class="align-items-center d-flex p-4">
            <span class="logo-lg">
              <img
                  :src="logoFromConfig()"
                  alt
                  height="40"
              />
            </span>
          <v-spacer></v-spacer>
          <h4>Tahsilat No: {{ collectionNumber }}</h4>
        </div>
        <div class="table-responsive p-4">
          <table class="table table-sm table-borderless">
            <tbody>
            <tr>
              <td>Ödeme Tarihi</td>
              <td>{{ date }}</td>
            </tr>
            <tr>
              <td>Ödeme Tipi</td>
              <td>{{ type === 1 ? 'Nakit' : 'Kredi Kartı' }}</td>
            </tr>
            <tr>
              <td>Cari Kod</td>
              <td>{{ selectedCurrent?.code }}</td>
            </tr>
            <tr>
              <td>Cari Adı</td>
              <td>{{ selectedCurrent?.name }}</td>
            </tr>
            <tr>
              <td>Plasiyer Bilgisi</td>
              <td>{{ selectedCurrent?.salesPersonName }}</td>
            </tr>
            <tr>
              <td>Ödenen Tutar</td>
              <td>{{ amount }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <PrintPage :divId="'receiptDialog'"></PrintPage>
        <v-btn small class="me-2" color="grey lighten-2" @click="dialog = false">Kapat</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>

import {numberConverter, printView} from "../../../helpers";
import {mapActions, mapState} from "vuex";
import {addBase64Prefix, logoFromConfig} from "@/base64Helper";
import {formattedDate} from "@/momentHelper";
import PrintPage from "@/components/shared/PrintPage.vue";

export default {
  components: {PrintPage},
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    collectionId: {
      type: String,
      default: ""
    },
  },
  computed: {
    ...mapState("settings", ["generalSettings"])
  },
  data() {
    return {
      dialog: false,
      date: null,
      selectedCurrent: null,
      description: null,
      amount: null,
      collectionNumber: null,
      type: null,
    }
  },
  methods: {
    numberConverter,
    formattedDate,
    logoFromConfig() {
      return logoFromConfig
    },
    addBase64Prefix,
    printView,
    ...mapActions("current", ["fetchSingleCurrent"]),
    ...mapActions("collactions", ["fetchSingleCollection"]),
    async _fetchCollectionSingle() {
      let collectionSingleResult = await this.fetchSingleCollection({
        params: {},
        body: {},
        urlSegments: [this.collectionId]
      });
      if (collectionSingleResult) {
        this.collectionNumber = collectionSingleResult.data.data.collectionNumber;
        this.type = collectionSingleResult.data.data.type;
        this.date = formattedDate(collectionSingleResult.data.data.date, "DD-MM-YYYY");
        this.description = collectionSingleResult.data.data.description;
        this.amount = numberConverter(collectionSingleResult.data.data.amount);
        this.selectedCurrent = await this.fetchSingleCurrent({
          params: {
            currentCode: collectionSingleResult.data.data.currentCode
          },
        });
      } else {
        this.type = null;
        this.date = null;
        this.selectedCurrent = null;
        this.description = null;
        this.amount = null;
      }
    },
  },
  watch: {
    "dialog": function (newVal) {
      this.$emit("dialogChange", newVal)
      if (newVal) {
        newVal;
      }
    },
    "showDialog": function (newVal) {
      this.dialog = newVal
      if (newVal) {
        this._fetchCollectionSingle()
      }
    },
  }
}
</script>

<style>
</style>